import React from 'react'

function PatientCard({stats}) {
  return (
   
            <div className="d-flex justify-content-around align-items-center p-2 bg-warning m-2 rounded-4" style={{height:"100px"}}>
                   <h2><i className="bi bi-people"></i></h2> 
                    <div className='d-flex flex-column'>
                        <span>Total Patient: {stats.totalPatients}</span>
                        <span>Active : {stats.activePatients}</span>
                    </div>
            </div>
  )
}

export default PatientCard